import React, { Component } from "react";
import { connect } from "react-redux";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import {
	DataGrid,
	Column,
	Button,
	SearchPanel,
	FilterRow,
	HeaderFilter,
	ColumnChooser,
	Export,
	Grouping,
	GroupPanel,
	Selection,
	Pager,
	Paging,
	StateStoring,
} from "devextreme-react/data-grid";
import { ExcelJS, Workbook } from "exceljs";
import saveAs from "file-saver";
import { exportDataGrid as exportDataGridToExcel } from "devextreme/excel_exporter";
import CustomStore from "devextreme/data/custom_store";
import { Link } from "@reach/router";
import VisibilityIcon from "@material-ui/icons/Visibility";
import GetAppIcon from "@material-ui/icons/GetApp";
import {
	triggerNotification,
	setLoading,
	triggerDialogForm,
	triggerDialog,
} from "../../../actions";
import { translationHook } from "../../translationHook";
import apiConfig from "../../../apis/apiConfig";
import { ButtonInfo, ButtonPrimary, ButtonSecondary } from "../../UI/Buttons";
import { downloadAttachment } from "./../../../apis/system/downloadAttachment";
import {
	getLicensesList,
	getLicensesDetails,
	getCompanyLegalFilesList,
} from "../../../apis/licenses/LicensesList";
import LicenseForm from "./LicenseForm";

class CompanyLegalFilesList extends Component {
	constructor(props) {
		super(props);
		this.onExporting = this.onExporting.bind(this);
		this.onToolbarPreparing = this.onToolbarPreparing.bind(this);
		// this.devRef = React.createRef(null);
		this.searchState = React.createRef();
	}

	state = {
		gridState: [],
		Btn_Refresh: 0,
		filesList: [],
	};

	componentDidMount() {
		this.loadState();

		(async () => {
			await getCompanyLegalFilesList(
				this.props.currentUser.Data.access_token,
				this.props.companyId
			).then((res) => {
				this.setState({
					Btn_Refresh: res.Btn_Refresh,
					filesList: res.Legal_Files_List,
				});
			});
		})();
	}

	saveState = async () => {
		const at = this.props.currentUser.Data.access_token,
			url = "API/SYSTEM/GENERAL/SAVE_USER_GRID_SETTINGS",
			bodyData = {
				System_Grid_Name: "Grid_Companies_Legal_Files_List",
				System_Grid_Json: this?.searchState?.current,
				Lang: this.props.i18n.language,
			};

		await apiConfig.post(url, bodyData, {
			headers: {
				Authorization: `Bearer ${at}`,
			},
		});

		this.props.triggerNotification(true, {
			Status: true,
		});
	};

	getState = async (state) => {
		if (state) {
			state.searchText = "";
			state.columns?.map((s) => (s.filterValue = undefined));
			this.searchState.current = JSON.stringify(state);
		}
	};

	loadState = async () => {
		const at = this.props.currentUser.Data.access_token,
			url = "API/SYSTEM/GENERAL/GET_USER_GRID_SETTINGS",
			bodyData = {
				System_Grid_Name: "Grid_Companies_Legal_Files_List",
				Lang: this.props.i18n.language,
			};

		const response = await apiConfig.post(url, bodyData, {
			headers: {
				Authorization: `Bearer ${at}`,
			},
		});

		if (response.data) {
			this.setState({
				gridState: JSON.parse(response?.data?.Data),
				// showGrid: true,
				pageSize: JSON.parse(response?.data?.Data)?.pageSize,
			});
		}
	};

	onToolbarPreparing(e) {
		e.toolbarOptions.items.unshift(
			{
				location: "after",
				widget: "dxButton",
				options: {
					text: this.props.t("saveGridSettings"),
					height: "36px",
					icon: "save",
					onClick: () => this.saveState(),
					hint: this.props.t("saveGridSettings"),
				},
			},
			{
				location: "after",
				widget: "dxButton",
				options: {
					text: this.props.t("clearSearch"),
					height: "36px",
					icon: "clearformat",
					onClick: () => this.dataGrid?.instance?.clearFilter(),
					hint: this.props.t("clearSearch"),
				},
			}
		);
	}

	handleOnContentReady = (e) => {
		if (this.props.i18n.language === "ar") {
			const scrollable = e.component?.getScrollable();
			const maxScrollLeft = scrollable?.scrollWidth();

			scrollable?.scrollTo({
				x: maxScrollLeft,
			});
		}
	};

	refreshAllFiles = async () => {
		const at = this.props.currentUser.Data.access_token,
			url =
				"/API/ADMINISTRATION/LICENSES/COMPANIES/LEGALFILES/Refresh_All_Company_Legal_Files",
			bodyData = {
				Company_Id: this.props.companyId,
			};

		this.props.setLoading(true, "dark");

		const response = await apiConfig
			.post(url, bodyData, {
				headers: {
					Authorization: `Bearer ${at}`,
				},
			})
			.then((res) => {
				if (res.data.Status) {
					this.props.setLoading(false);

					this.props.triggerNotification(true, {
						Status: true,
					});

					this.setState({
						Btn_Refresh: res.data.Data.Btn_Refresh,
						filesList: res.data.Data.Legal_Files_List,
					});
				} else {
					throw res;
				}
				return res;
			})
			.catch((err) => {
				this.props.setLoading(false);

				this.props.triggerNotification(
					true,
					err.response ? err.response.data : err.data
				);

				return err;
			});
	};

	refreshFile = async (record) => {
		const at = this.props.currentUser.Data.access_token,
			url =
				"/API/ADMINISTRATION/LICENSES/COMPANIES/LEGALFILES/Refresh_Company_Legal_File",
			bodyData = {
				Company_Id: this.props.companyId,
				License_Attachment_File_Code:
					record.data.License_Attachment_File_Code,
			};
		this.props.setLoading(true, "dark");

		const response = await apiConfig
			.post(url, bodyData, {
				headers: {
					Authorization: `Bearer ${at}`,
				},
			})
			.then((res) => {
				if (res.data.Status) {
					this.props.setLoading(false);

					this.props.triggerNotification(true, {
						Status: true,
					});

					this.setState({
						Btn_Refresh: res.data.Data.Btn_Refresh,
						filesList: res.data.Data.Legal_Files_List,
					});
				} else {
					throw res;
				}
				return res;
			})
			.catch((err) => {
				this.props.setLoading(false);

				this.props.triggerNotification(
					true,
					err.response ? err.response.data : err.data
				);

				return err;
			});
	};

	render() {
		const jsonDataSource = new CustomStore({
			key: "License_Attachment_Data_Id",
			load: () => {
				return this.state.filesList;
			},
		});

		return (
			<>
				<div className="d-flex justify-content-between align-items-center mb-4">
					<h3>{this.props.t("companyLegalFilesList")}</h3>
					{!!this.state.Btn_Refresh && (
						<ButtonPrimary
							className="mx-2"
							color="primary"
							variant="contained"
							onClick={() => {
								this.refreshAllFiles();
							}}
						>
							{this.props.t("refreshAllFiles")}
						</ButtonPrimary>
					)}
				</div>

				{this.state.gridState?.columns && (
					<DataGrid
						className={[
							this.props.i18n.language === "ar"
								? "dx-grid-ar"
								: "dx-grid-en",
							"globalBox",
						].join(" ")}
						id="dataGrid"
						width={"100%"}
						dataSource={jsonDataSource}
						showBorders={false}
						showColumnLines={false}
						showRowLines={true}
						allowColumnResizing={true}
						columnResizingMode={"widget"}
						allowColumnReordering={true}
						rowAlternationEnabled={false}
						focusedRowEnabled={true}
						onExporting={this.onExporting}
						columnWidth={"auto"}
						wordWrapEnabled={true}
						rtlEnabled={
							this.props.i18n.language === "ar" ? true : false
						}
						onToolbarPreparing={this.onToolbarPreparing}
						ref={(ref) => (this.dataGrid = ref)}
						bounceEnabled={false}
						onOptionChanged={(e) => {
							if (e?.fullName == "paging.pageSize") {
								this.setState({ pageSize: e.value });
							}

							if (e.fullName.split(".").pop() == "filterValue") {
								this.dataGrid.instance.refresh();
							}
						}}
						onContentReady={this.handleOnContentReady}
						remoteOperations={false}
					>
						<ColumnChooser
							enabled={true}
							allowSearch={true}
							search={"fff"}
							title={this.props.t("dxColumnChooserTitle")}
							emptyPanelText={this.props.t(
								"dxColumnChooserPanelText"
							)}
						/>

						<StateStoring
							enabled={true}
							type="custom"
							// customLoad={this.loadState}
							customSave={this.getState}
						/>

						<SearchPanel
							visible={true}
							width={240}
							placeholder={this.props.t("search")}
						/>

						<FilterRow visible={true} />

						<HeaderFilter visible={true} />

						<Export enabled={true} allowExportSelectedData={true} />

						<Grouping
							contextMenuEnabled={true}
							expandMode="rowClick"
						/>
						<GroupPanel
							visible={true}
							emptyPanelText={this.props.t("dxGroupPanelText")}
						></GroupPanel>

						<Selection
							mode="multiple"
							selectAllMode={"allPages"}
							showCheckBoxesMode={"always"}
						/>

						<Paging
							enabled={true}
							defaultPageSize={this.state.pageSize}
							pageSize={this.state.pageSize}
						/>

						<Pager
							visible="true"
							allowedPageSizes={[5, 10, 20, 50, 100]}
							displayMode="full"
							showPageSizeSelector="true"
							showInfo="true"
							infoText=""
							showNavigationButtons="true"
						/>

						{this.state.gridState?.columns
							?.filter((d) => d?.name !== "buttons")
							?.map((d, i) => (
								<Column
									dataField={d?.dataField}
									caption={d?.name}
									alignment={
										this.props.i18n.language === "ar"
											? "right"
											: "left"
									}
									visible={d?.visible}
									width={d?.width ? d.width : "auto"}
									dataType={d?.dataType}
									format={
										d?.dataType == "date"
											? "yyyy-MM-dd"
											: ""
									}
								></Column>
							))}

						<Column
							cssClass="outlinedColumn nowrapColumn"
							type="buttons"
							caption={this.props.t("details")}
							fixed={true}
							fixedPosition={
								this.props.i18n.language === "ar"
									? "left"
									: "right"
							}
							width="250px"
						>
							<Button
								render={(record) => {
									return (
										<div>
											<GetAppIcon
												style={{
													cursor: "pointer",
													marginInline: "8px",
												}}
												onClick={async () => {
													let params = {
														at: this.props
															.currentUser.Data
															.access_token,
														File_Code:
															record.data
																.License_Attachment_File_Code,
													};
													const downloadResult =
														await downloadAttachment(
															params
														);
													const url =
														window.URL.createObjectURL(
															new Blob(
																[
																	downloadResult.data,
																],
																{
																	type: "application/pdf",
																}
															)
														);
													const link =
														document.createElement(
															"a"
														);
													link.href = url;
													link.setAttribute(
														"target",
														"_blank"
													);
													link.click();
												}}
											/>

											<ButtonInfo
												style={{
													marginInline: "8px",
												}}
												variant="circleIcon"
												startIcon={<VisibilityIcon />}
												onClick={async () => {
													let params = {
														at: this.props
															.currentUser.Data
															.access_token,
														File_Code:
															record.data
																.License_Attachment_File_Code,
													};
													const downloadResult =
														await downloadAttachment(
															params
														);

													if (
														downloadResult.status ===
														200
													) {
														let contentType =
																downloadResult
																	.headers[
																	"content-type"
																],
															typesArray = [
																"application/pdf",
																"image/bmp",
																"image/gif",
																"image/vnd.microsoft.icon",
																"image/jpeg",
																"image/png",
																"image/svg+xml",
																"image/tiff",
																"image/webp",
															],
															url =
																window.URL.createObjectURL(
																	new Blob(
																		[
																			downloadResult.data,
																		],
																		{
																			type: contentType,
																		}
																	)
																),
															link =
																document.createElement(
																	"a"
																);
														let File_Name;
														if (
															downloadResult?.data
																?.Data
																?.File_Bytes
														) {
															url =
																window.URL.createObjectURL(
																	new Blob(
																		[
																			downloadResult
																				.data
																				.Data
																				.File_Bytes,
																		],
																		{
																			type: contentType,
																		}
																	)
																);
															File_Name =
																downloadResult
																	.data.Data
																	.File_Name;
														}
														link.href = url;
														typesArray.includes(
															contentType
														)
															? link.setAttribute(
																	"target",
																	"_blank"
															  )
															: link.setAttribute(
																	"download",
																	File_Name
															  );
														document.body.appendChild(
															link
														);
														link.click();
													}
												}}
											>
												{/* {this.props.t('view')} */}
											</ButtonInfo>

											{!!this.state.Btn_Refresh && (
												<ButtonSecondary
													variant="outlined"
													style={{
														marginInline: "8px",
													}}
													onClick={() => {
														this.refreshFile(
															record
														);
													}}
												>
													{this.props.t("refresh")}
												</ButtonSecondary>
											)}
										</div>
									);
								}}
							/>
						</Column>
					</DataGrid>
				)}
			</>
		);
	}

	onExporting(e) {
		let sheetTitle = this.props.t("licenselist");
		const workbook = new Workbook();
		const worksheet = workbook.addWorksheet("Main sheet");
		exportDataGridToExcel({
			component: e.component,
			worksheet: worksheet,
			autoFilterEnabled: true,
			topLeftCell: { row: 2, column: 2 },
			topRightCell: { row: 2, column: 2 },
			customizeCell: ({ gridCell, excelCell }) => {
				// excelCell.value = gridCell.value;
				excelCell.font = {
					family: 2,
					name: "Cairo",
					size: 10,
					color: { argb: "151713" },
				};
				excelCell.alignment = {
					indent: 1,
					wrapText: true,
					vertical: "middle",
				};
				if (gridCell.rowType === "group") {
					excelCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "d0b166" },
					};
					excelCell.alignment = { indent: 2 };
					excelCell.font = {
						family: 2,
						name: "Cairo",
						size: 10,
						color: { argb: "ffffff" },
						bold: true,
					};
				}
				if (gridCell.rowType === "header") {
					excelCell.fill = {
						type: "pattern",
						pattern: "solid",
						fgColor: { argb: "58743a" },
					};
					excelCell.alignment = {
						vertical: "middle",
						horizontal: "center",
					};
					excelCell.font = {
						family: 2,
						name: "Cairo",
						size: 12,
						color: { argb: "ffffff" },
						bold: true,
					};
				}
			},
		}).then(function () {
			workbook.xlsx.writeBuffer().then(function (buffer) {
				saveAs(
					new Blob([buffer], { type: "application/octet-stream" }),
					`${sheetTitle}.xlsx`
				);
			});
		});
		e.cancel = true;
	}
}

const mapStateToProps = (state) => {
	return {
		currentUser: state.currentUser,
		reload: state.reload,
	};
};

export default connect(mapStateToProps, {
	triggerDialog,
	triggerNotification,
	setLoading,
	triggerDialogForm,
})(translationHook(CompanyLegalFilesList));
